import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-95ebb638"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "columns small-12" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Webhook ID", -1 /* HOISTED */));
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "columns small-12" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Options", -1 /* HOISTED */));
const _hoisted_7 = { class: "option-row" };
const _hoisted_8 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_9 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_10 = ["onUpdate:modelValue"];
const _hoisted_11 = ["onClick"];
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerEnumListVariableMutableFields',
    props: {
        componentMutable: {}
    },
    setup(__props) {
        const props = __props;
        const webhookId = computed({
            get: () => props.componentMutable.getWebhookId(),
            set: (value) => {
                props.componentMutable.setWebhookId(value);
            },
        });
        const options = computed({
            get: () => props.componentMutable.getOptions(),
            set: (value) => {
                props.componentMutable.setOptions(value);
            },
        });
        const addOption = () => {
            const newOptions = [...options.value];
            newOptions.push({ id: "", name: "", default: "" });
            options.value = newOptions;
        };
        const removeOption = (index) => {
            const newOptions = [...options.value];
            newOptions.splice(index, 1);
            if (newOptions.length === 0) {
                newOptions.push({ id: "", name: "", default: "" });
            }
            options.value = newOptions;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((webhookId).value = $event)),
                            type: "text",
                            placeholder: "Enter webhook ID"
                        }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, webhookId.value]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "input-wrapper"
                            }, [
                                _createElementVNode("div", _hoisted_7, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event) => ((option.id) = $event),
                                        type: "text",
                                        placeholder: 'Enter ID ' + (index + 1)
                                    }, null, 8 /* PROPS */, _hoisted_8), [
                                        [_vModelText, option.id]
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event) => ((option.name) = $event),
                                        type: "text",
                                        placeholder: 'Enter name ' + (index + 1)
                                    }, null, 8 /* PROPS */, _hoisted_9), [
                                        [_vModelText, option.name]
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event) => ((option.default) = $event),
                                        type: "text",
                                        placeholder: 'Enter default value'
                                    }, null, 8 /* PROPS */, _hoisted_10), [
                                        [_vModelText, option.default]
                                    ]),
                                    (options.value.length > 1)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "button button--secondary button--medium",
                                            type: "button",
                                            onClick: ($event) => (removeOption(index))
                                        }, " Remove ", 8 /* PROPS */, _hoisted_11))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]));
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createElementVNode("div", { class: "button-wrapper text-left" }, [
                            _createElementVNode("button", {
                                class: "button button--secondary button--medium",
                                type: "button",
                                onClick: addOption
                            }, " + Add Option ")
                        ])
                    ])
                ])
            ]));
        };
    }
});
